// Textos curtos das listas de aparelhos no celular (Dashboard, Dispositivos,
// Logs). A coluna da direita do item de lista tem pouco espaço: "Há 3 horas"
// do formatRelativeTime não cabe ao lado da versão, então aqui vai o formato
// do desenho aprovado ("agora", "há 4 min", "13:38", "ontem", "02/06").

export function tempoCurto(
  data: string | Date | null | undefined,
  agora: Date = new Date()
): string {
  if (!data) return 'nunca';
  const d = typeof data === 'string' ? new Date(data) : data;
  if (isNaN(d.getTime())) return 'nunca';

  const minutos = Math.floor((agora.getTime() - d.getTime()) / 60000);
  // Relógio do aparelho adiantado gera data no futuro; trata como agora.
  if (minutos < 1) return 'agora';
  if (minutos < 60) return `há ${minutos} min`;

  const doisDigitos = (n: number) => String(n).padStart(2, '0');
  const mesmoDia = (a: Date, b: Date) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();

  if (mesmoDia(d, agora)) return `${doisDigitos(d.getHours())}:${doisDigitos(d.getMinutes())}`;

  const ontem = new Date(agora);
  ontem.setDate(agora.getDate() - 1);
  if (mesmoDia(d, ontem)) return 'ontem';

  const diaMes = `${doisDigitos(d.getDate())}/${doisDigitos(d.getMonth() + 1)}`;
  return d.getFullYear() === agora.getFullYear()
    ? diaMes
    : `${diaMes}/${String(d.getFullYear()).slice(-2)}`;
}

// Versão do app com "v" na frente, sem duplicar quando já vem com ele.
export function rotuloVersao(versao: string | null | undefined): string {
  const v = (versao || '').trim();
  if (!v) return '';
  return /^v/i.test(v) ? v : `v${v}`;
}

// A API manda a plataforma em minúsculas; a tela mostra o nome da marca.
export function nomePlataforma(plataforma: string | null | undefined): string {
  const p = (plataforma || '').toLowerCase().trim();
  if (p === 'ios') return 'iOS';
  if (p === 'android') return 'Android';
  if (p === 'web') return 'Web';
  return plataforma || 'Outro';
}
